export const PLAN_AMOUNTS = {
  year: 4500,
  month: 500,
}

export const TERMS = {
  year: 'yearly',
  month: 'monthly',
}
